import { render, staticRenderFns } from "./file.vue?vue&type=template&id=4dcba99c"
import script from "./file.vue?vue&type=script&lang=js"
export * from "./file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dcba99c')) {
      api.createRecord('4dcba99c', component.options)
    } else {
      api.reload('4dcba99c', component.options)
    }
    module.hot.accept("./file.vue?vue&type=template&id=4dcba99c", function () {
      api.rerender('4dcba99c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/file.vue"
export default component.exports